import { render, staticRenderFns } from "./uploadPicInput.vue?vue&type=template&id=ccfbb4d0&"
import script from "./uploadPicInput.vue?vue&type=script&lang=js&"
export * from "./uploadPicInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports